import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, markRaw, ref, defineAsyncComponent } from "vue";
import { AppRootEnum } from "./app-root-enum";


export default /*@__PURE__*/_defineComponent({
  __name: 'component-loader',
  props: {
    componentName: {},
    showLoader: { type: Boolean, default: true },
    dataProps: {},
    appRoot: {}
  },
  setup(__props: any) {

const props = __props;

const root = ref(null);

const componentDestinationPath = computed(() => {
    return props.componentName.substring(0, props.componentName.lastIndexOf("/"));
});

const componentName = computed(() => {
    return props.componentName.split("/").slice(-1)?.[0];
});

const getComponentPath = () => {
    switch (props.appRoot) {
        case AppRootEnum.standalone:
            return import(`../standalone-pages/${componentDestinationPath.value}/_${componentName.value}.vue`);
        case AppRootEnum.sharedComponents:
            return import(
                `../../../../libs/shared-components/${componentDestinationPath.value}/_${componentName.value}.vue`
            );
        default:
            return import(`../app/${componentDestinationPath.value}/_${componentName.value}.vue`);
    }
};

const componentType = markRaw(defineAsyncComponent(() => getComponentPath()));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(componentType)), _mergeProps({
    ref_key: "root",
    ref: root
  }, _ctx.dataProps), null, 16))
}
}

})